import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import style from "../components/watisweef.module.scss"
import Fig from "./Fig"

function createMarkup(tekst) {
  return { __html: tekst }
}

export default function Kapelhuis({ tekstCol, fotoCol, row}) {
  const data = useStaticQuery(
    graphql`
      query MyKapel {
        tekstJson {
          pagina {
            kapelhuis {
              body
              kop
            }
          }
        }
        kapelhuis: file(relativePath: { eq: "kapelhuis.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 400, maxHeight: 400, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        vazen: file(relativePath: { eq: "vazen.png" }) {
          childImageSharp {
            fluid(maxWidth: 400, maxHeight: 400, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  const cols = ["1/8", "6/13", "11/18", "16/23"]

  return (
    <div className={style.wrapper} style = {{gridRow: row}}>
      <div className={style.tekst} style={{ gridColumn: cols[tekstCol - 1] }}>
        <h2>{data.tekstJson.pagina.kapelhuis.kop}</h2>
        <p
          dangerouslySetInnerHTML={createMarkup(
            data.tekstJson.pagina.kapelhuis.body
          )}
        />
      </div>
      <div className={style.fotos} style={{ gridColumn: cols[fotoCol - 1], padding: "0em 15%" }}>
        <Fig image={data.kapelhuis.childImageSharp.fluid} caption="Het Kapelhuis Amersfoort" stylo = {{width: '100%', height: '20vw'}} imgStylo={{transform: 'scaleX(-1)', position: 'absolute', left: '0px', top: '50px'}}></Fig>
        <Fig image={data.vazen.childImageSharp.fluid} caption="Marcel Wanders, Vazen, 1990</br>Eerbetoon aan Hyke Koopmans en Margje Blitterswijk.</br>Foto Leendert Jansen" stylo = {{width: '100%', height: '20vw'}}></Fig>
      </div>
    </div>
  )
}


// imgStylo={{transform: 'scaleX(-1)', position: 'absolute', left: '0px', top: '50px'}}